import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicPrescriptionCreatedDetail from './ElectronicPrescriptionCreatedDetail';
import useTranslation from '../../../../../Hooks/useTranslation';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	messageId: string;
	result: any,
	disableMultiplePrescription?: boolean;
}

const ElectronicPrescriptionCreatedDetailModal: React.FC<Props> = props => {
	const { opened, onClose, messageId, result, disableMultiplePrescription } = props;
	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(true)}
			fullScreen={false}
			wrapChat={isCase}>
			<Modal.Header title={t('nczi.electronicPrescription.detail.title') + ' ' + (result?.barcode || '')} />
			<Modal.Content>
				<ElectronicPrescriptionCreatedDetail
					onClose={onClose}
					messageId={messageId}
					result={result}
					disableMultiplePrescription={disableMultiplePrescription}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicPrescriptionCreatedDetailModal;
